if (typeof customElements.get('product-upsell-slider') === 'undefined') {
  class ProductUpsellSlider extends HTMLElement {
    connectedCallback() {
      this._viewport = this.querySelector('[data-upsell-viewport]');
      this._track = this.querySelector('[data-upsell-track]');
      this._slides = this.querySelectorAll('[data-upsell-slide]');
      this._prev = this.querySelector('[data-upsell-prev]');
      this._next = this.querySelector('[data-upsell-next]');
      this._index = 0;
      this._dragThreshold = 40;

      if (!this._track || !this._viewport) return;

      if (this._slides.length <= 1) {
        if (this._prev) this._prev.disabled = true;
        if (this._next) this._next.disabled = true;
        return;
      }

      this._prev?.addEventListener('click', () => this.go(-1));
      this._next?.addEventListener('click', () => this.go(1));
      this._bindDrag();
      this._update(false);
    }

    go(step) {
      this._index = Math.max(0, Math.min(this._slides.length - 1, this._index + step));
      this._update(true);
    }

    _update(animate) {
      if (animate !== false) {
        this._track.style.transition = '';
      }
      this._track.style.transform = `translate3d(-${this._index * 100}%, 0, 0)`;
      if (this._prev) this._prev.disabled = this._index === 0;
      if (this._next) this._next.disabled = this._index >= this._slides.length - 1;
    }

    _bindDrag() {
      let startX = 0;
      let startTranslate = 0;
      let dragging = false;
      let pointerId = null;

      const slideWidth = () => this._viewport.offsetWidth || 1;

      const onPointerDown = (event) => {
        if (event.pointerType === 'mouse' && event.button !== 0) return;
        if (event.target.closest('a, button, input, textarea, select, label, form, quick-add-to-cart, product-form')) {
          return;
        }
        dragging = true;
        pointerId = event.pointerId;
        startX = event.clientX;
        startTranslate = -this._index * slideWidth();
        this._viewport.classList.add('is-dragging');
        this._viewport.setPointerCapture?.(pointerId);
      };

      const onPointerMove = (event) => {
        if (!dragging || event.pointerId !== pointerId) return;
        const delta = event.clientX - startX;
        let nextTranslate = startTranslate + delta;

        const min = -(this._slides.length - 1) * slideWidth();
        const max = 0;
        if (nextTranslate > max) nextTranslate = max + (nextTranslate - max) * 0.35;
        if (nextTranslate < min) nextTranslate = min + (nextTranslate - min) * 0.35;

        this._track.style.transform = `translate3d(${nextTranslate}px, 0, 0)`;
      };

      const onPointerUp = (event) => {
        if (!dragging || (event.pointerId != null && event.pointerId !== pointerId)) return;
        dragging = false;
        pointerId = null;
        this._viewport.classList.remove('is-dragging');

        const delta = event.clientX - startX;
        if (Math.abs(delta) >= this._dragThreshold) {
          this.go(delta > 0 ? -1 : 1);
        } else {
          this._update(true);
        }

        try {
          this._viewport.releasePointerCapture?.(event.pointerId);
        } catch (_) {
          /* ignore */
        }
      };

      this._viewport.addEventListener('pointerdown', onPointerDown);
      this._viewport.addEventListener('pointermove', onPointerMove);
      this._viewport.addEventListener('pointerup', onPointerUp);
      this._viewport.addEventListener('pointercancel', onPointerUp);
    }
  }

  customElements.define('product-upsell-slider', ProductUpsellSlider);
}
